import React, { useEffect, useState } from 'react'
import TwoLineBanner from 'shared/components/two-line-banner'
import qs from 'query-string'

export const RedirectBanner = () => {
    const [triggerBanner, setTriggerBanner] = useState<boolean | null>(null)

    useEffect(() => {
        const nextParam = qs.parse(location.search)
        // If there is a hire url parameter, trigger the 'For Hire' banner.
        if (nextParam?.hire === 'true') {
            setTriggerBanner(true)
        }
    }, [])

    return (
        <>
            {triggerBanner && (
                <TwoLineBanner
                    title="Sign Up to Contact GIPHY Artists"
                    description="You must have a GIPHY Account to get in touch with the world's best GIF &amp; Motion Designers!"
                    linkDestination="https://support.giphy.com/hc/en-us/articles/360022661172-How-to-Hire-A-GIF-Artist-on-GIPHY"
                    linkLabel="Learn More about GIF Commissions"
                />
            )}
        </>
    )
}

export default RedirectBanner
